const muiTheme = {
  palette: {
    primary1Color: '#F6D103'
  },
  table: {
    height: 'calc(100vh - 122px)'
  },
  tableHeaderColumn: {
    fontSize: '14px'
  },
  datePicker: {
    selectColor: '#F6D103',
    headerColor: '#F6D103'
  },
  timePicker: {
    headerColor: '#F6D103',
  },
};
const theme = muiTheme
export default theme;



// WEBPACK FOOTER //
// ./src/lib/bpjs-theme.js